import { useState, useEffect, useCallback } from "react";
import dayjs from "dayjs";
import api from "../utils/api"; // 🔥 ekledik

export function useUniqueTvData(channelId, startDate, endDate, refreshKey = 0) {
  const [rawUniqueTv, setRawUniqueTv] = useState(null);
  const [loading, setLoading] = useState(true);

  const loadUniqueTv = useCallback(async () => {
    if (!channelId) return;

    try {
      const start = startDate
        ? dayjs(startDate).format("YYYY-MM-DD")
        : dayjs().subtract(7, "day").format("YYYY-MM-DD");

      const end = endDate
        ? dayjs(endDate).add(1, "day").format("YYYY-MM-DD")
        : dayjs().add(1, "day").format("YYYY-MM-DD");

      const res = await api.get(
        `/u?c=${channelId}&start=${start}&end=${end}` // 🔥 değişti
      );

      const raw = res.data;
      setRawUniqueTv(raw && typeof raw === "object" ? raw : {});
    } catch (err) {
      console.error("Unique TV fetch error:", err);
      setRawUniqueTv({});
    } finally {
      setLoading(false);
    }
  }, [channelId, startDate, endDate]);

  useEffect(() => {
    setLoading(true);
    loadUniqueTv();
  }, [loadUniqueTv, refreshKey]);

  return { data: rawUniqueTv, loading };
}